module.exports = react-native-quick-sqlite;